import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { CustomerModel } from 'projects/core/src/lib/models/customer.model';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.scss']
})
export class CustomerListComponent extends BaseList implements OnInit {

  public customers: Array<CustomerModel> = [];
  public apiUrl = '/customers';

  protected rightLoad = 'admin.customer.list';
  protected rightNew = 'admin.customer.create';
  protected rightOpen = 'admin.customer.show';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected auth: AuthStateService,
    public transloco: TranslocoService
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.customers'));
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('customers').subscribe({
      next: (customers: any) => {
        this.customers = [];
        customers.data.forEach((customer: any) => {
          this.customers.push(new CustomerModel().deserialize(customer));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
